<template>
  <header class="mb-5 container-fluid">
    <!-- mobile menu -->
    <div class="row menu mobile">
      <div class="col-lg-12 npmm">
        <div class="topnav mobile">
          <router-link @click.native="dropDownItemClickHandler" :to="`/`" class="mobile-logo-main">
            <div class="logo">
              <img class="img-fluid" src="@/assets/images/mob-logo.svg" alt="">
            </div>
          </router-link>
          <div id="myLinks" class="d-none">
            <div class="dropdown" v-if="!this.$store.getters.hasC1868Role">
              <a type="button" class="dropdown-toggle text-white">
                Products
              </a>
              <ul class="dropdown-mobile">
                <span v-for="category in menuTopCategories" :key="category.id">
                  <router-link :to="`/category/` + category.id + '/products'" @click.native="dropDownItemClickHandler" class="dropdown-item" v-if="category.is_menu_top">
                    {{category.name}}
                  </router-link>
                </span>
                <a class="dropdown-item middel-d  p-0 my-2"></a>
                <span v-for="category in menuBottomCategories" :key="category.id">
                  <router-link :to="`/category/` + category.id + '/products'" @click.native="dropDownItemClickHandler" class="dropdown-item" v-if="!category.is_menu_top">
                    {{category.name}}
                  </router-link>
                </span>
              </ul>
            </div>
            <div class="dropdown" v-if="!this.$store.getters.hasC1868Role">
              <a type="button" class="dropdown-toggle text-white">
                Categories
              </a>
              <ul class="dropdown-mobile">
                <span v-for="category in homepageCategories" :key="category.label">
                  <router-link @click.native="dropDownItemClickHandler" :to="category.link" class="dropdown-item">
                    {{category.label}}
                  </router-link>
                </span>
              </ul>
            </div>

            <router-link :to="`/help`" @click.native="dropDownItemClickHandler">Help</router-link>
            <a href="javascript:void(0)" @click="logout">Logout</a>

          </div>
          <a href="javascript:void(0);" class="icon" @click="toggleMobileMenu">
            <i class="fa fa-bars"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- desktop menu -->
    <div class="row menu desktop">
      <div class="col-xl-3 col-lg-4 col-md-4">
        <div class="logo-main d-flex align-items-center">
          <div class="logo">
            <router-link :to="`/`">
              <img class="img-fluid" src="@/assets/images/logo2.svg" alt="">
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 d-flex justify-content-center">
        <ul class="nav">
          <li v-if="!this.$store.getters.hasC1868Role">
            <div class="dropdown">
              <a type="button" class="dropdown-toggle text-white" data-toggle="dropdown">
                Products
              </a>
              <div class="dropdown-menu">
                <span v-for="category in menuTopCategories" :key="category.id">
                  <router-link :to="`/category/` + category.id + '/products'" class="dropdown-item">
                    {{category.name}}
                  </router-link>
                </span>
                <a class="dropdown-item middel-d  p-0 my-2" href="#"></a>
                <span v-for="category in menuBottomCategories" :key="category.id">
                  <router-link :to="`/category/` + category.id + '/products'" class="dropdown-item">
                    {{category.name}}
                  </router-link>
                </span>
              </div>
            </div>
          </li>
          <li v-if="!this.$store.getters.hasC1868Role">
            <div class="dropdown">
              <a type="button" class="dropdown-toggle text-white" data-toggle="dropdown">
                Categories
              </a>
              <div class="dropdown-menu">
                <span v-for="category in homepageCategories" :key="category.label">
                  <router-link :to="category.link" class="dropdown-item">
                    {{category.label}}
                  </router-link>
                </span>
              </div>
            </div>
          </li>
          <li><router-link :to="`/help`">Help</router-link></li>
          <li><a href="javascript:void(0)" @click="logout">Logout</a></li>
        </ul>
      </div>
      <div v-if="this.$store.getters.user.role === 'admin' || this.$store.getters.user.role === 'martinellis'" class="col-xl-3 col-lg-2 col-md-2 d-flex align-items-center justify-content-center">
        <form @submit="submitSearch" class="search">
          <div class="d-flex align-items-center">
            <input type="text" placeholder="Search" v-model="search" class="form-control">
            <button class="btn-search-submit" type="submit"><i class="fa fa-arrow-right"></i></button>
          </div>
        </form>
      </div>
    </div>
  </header>
</template>

<script>
import Category from '@/models/Category.js'
export default{
  name: 'Navbar',
  data () {
    return {
      search: '',
      menuTopCategories: null,
      menuBottomCategories: null,
      homepageCategories: [{
        label: 'Photos',
        image: '/static/images/photos.png',
        link: '/photos'
      }, {
        label: 'Branding & Logos',
        image: '/static/images/brandings.png',
        link: '/branding-and-logos'
      }, {
        label: 'Presentation Materials',
        image: '/static/images/presentations.png',
        link: '/presentation-materials'
      }, {
        label: 'Advertisements',
        image: '/static/images/ads.png',
        link: '/ads'
      }, {
        label: 'Sell Sheets',
        image: '/static/images/sell-sheets.png',
        link: '/sell-sheet-categories'
      }, {
        label: 'Public Relations',
        image: '/static/images/public-relations.png',
        link: '/public-relations'
      }, {
        label: 'Videos',
        image: '/static/images/videos.png',
        link: '/videos'
      }, {
        label: '1868',
        image: '/static/images/c1868s.png',
        link: '/1868s'
      }]
    }
  },
  mounted () {
    this.fetchCategories()
    // $('.dropdown-toggle').click(function () {
    //   $('.dropdown-mobile').toggleClass('show')
    // })
  },
  methods: {
    submitSearch (event) {
      event.preventDefault()
      let search = this.search
      if (search === '') {
        this.$toast.error('Search field is required')
        return
      }
      this.search = ''
      // eslint-disable-next-line handle-callback-err
      this.$router.push('/search?query=' + search).catch((err) => {})
    },
    logout (event) {
      event.preventDefault()
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
          this.$toast.success('Logged out successfully')
        })
        .catch((err) => {
          console.log(err)
          this.$toast.error(err.response.data.message)
        })
    },
    fetchCategories () {
      this.menuTopCategories = []
      this.menuBottomCategories = []
      this.$store.dispatch('fetchCategories')
        .then((result) => {
          var menuTop = result.data.categories.filter(a => a.is_menu_top === '1' || a.is_menu_top === 1)
          var menuBottom = result.data.categories.filter(a => a.is_menu_top === '0' || a.is_menu_top === 0)
          menuTop.forEach(category => {
            this.menuTopCategories.push(new Category(category))
          })
          menuBottom.forEach(category => {
            this.menuBottomCategories.push(new Category(category))
          })
        })
        .catch((err) => this.$helper.catchHandler(err))
    },
    toggleMobileMenu () {
      $('#myLinks').toggleClass('d-none')
    },
    dropDownItemClickHandler () {
      $('.dropdown-mobile').removeClass('show')
      $('#myLinks').addClass('d-none')
    }
  }
}
</script>

<style scoped>
.search {
  /* position: relative; */
}
.btn-search-submit {
  background: white;
  border: 0px;
  border-radius: 50%;
  padding: 6px;
  padding-top: 5px;
  padding-left: 7px;
  height: 26px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-left: 13px;
  color: white;
}
.btn-search-submit .fa {
  color: #c5263c;
}
.search input:focus {
  box-shadow: none;
}
.btn-search-submit:focus,
.btn-search-submit:active {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue